module.exports = __webpack_public_path__ + "img/vpc11.74bfcd7.png";